import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const ConditionsContent = ({data}) => {

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, 'Condições dos indivíduos', 'individual-condition-data');
    }, [data]);

    return (
        <>
            <div id="individual-table">
                <div className="chart mt-3">
                    <span className="chart-title">Condições dos indivíduos nos {data.boName}</span>
                </div>

                <table id={'individual-condition-data'} className="table report-table mt-2" sheet-name={'Condições dos indivíduos'}>
                    <thead className="thead-background">
                        <tr>
                            <th className={"text-left"}>Condição</th>
                            <th>Homens</th>
                            <th>Mulheres</th>
                            <th>Não informado</th>
                            <th>Total de indivíduos</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                    {
                        data.conditions.map((element, index) => {
                            return (
                                <tr key={index} className={"text-center"}>
                                    <td className={"text-left"}>{element.conditions}</td>
                                    <td>{element.male_total}</td>
                                    <td>{element.female_total}</td>
                                    <td>{element.undefined_t}</td>
                                    <td>{element.total}</td>
                                </tr>
                            )
                        })
                    }

                    {
                        <tr className={"text-center"}>
                            <td className={"text-left"}><strong>Total de indivíduos</strong></td>
                            <td>{data.getAllIndividualCount[0]?.male_total}</td>
                            <td>{data.getAllIndividualCount[0]?.female_total}</td>
                            <td>{data.getAllIndividualCount[0]?.undefined_total}</td>
                            <td>{data.getAllIndividualCount[0]?.total}</td>
                        </tr>
                    }
                    </tbody>
                </table>

                <span className="obs-warn">* Um indivíduo pode estar associado a múltiplas condições.</span>

            </div>

            <div className="chart-divisor"></div>
        </>
    );
};

export default ConditionsContent;